var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("static/sound/map_marker.png")

  var m1 = require("static/sound/rIcon.png")

  var m2 = require("static/sound/microphone.png")

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      !_vm.bool ? _vm.publish() : ""
    }

    _vm.e1 = function($event) {
      _vm.boolShow = false
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }